import React, { Component } from 'react';
import "../CSS/fonts/OpenSans-Bold.eot";
import "../CSS/fonts/OpenSans-Bold.ttf";
import "../CSS/fonts/OpenSans-Regular.eot";
import "../CSS/fonts/OpenSans-Regular.ttf";
import "../CSS/fonts/OpenSans-Semibold.eot";
import "../CSS/fonts/OpenSans-Semibold.ttf";
import "../CSS/CustomStyles.css";
import "../CSS/Draft-js.css";
import moment from "moment";

class VersionRow extends Component {
    render() {
        return (<tr key={this.props.versionIndex} >
            <td><a href="javascript:void(0)" onClick={this.props.editVersion} className="table-link">{this.props.rowData.publishedDate}</a></td>
            <td><a href="javascript:void(0)" onClick={this.props.editVersion} className="table-link">{this.props.rowData.version}</a></td>
            <td><a href="javascript:void(0)" onClick={this.props.editVersion} className="table-link">{moment.utc(this.props.rowData.createdDate).format('YYYY-MM-DD')}</a></td>
            <td><a href="javascript:void(0)" onClick={this.props.editVersion} className="table-link">{this.props.rowData.published ? "Published" : "Draft"}</a></td>
            <td className="CA-DeleteRow"><a href="javascript:void(0)" className="hideShow" title="Delete item" onClick={this.props.deleteVersion}><img src={require("../images/DeleteIcon.png")} alt="Delete" /></a></td>
        </tr>);
    }
}

export default class VersionGrid extends Component {
    constructor(props) {
        super(props);
        const { versionData } = this.props;
        const recordsToLoad = 10;
        const loadData = versionData.length > recordsToLoad ? versionData.slice(0, recordsToLoad) : versionData;
        this.state = {
            loadData: loadData, currentPage: 1, loadDataLength: recordsToLoad, newPage: "1", versionDataLength: versionData.length
        };
        this.ChangePage = this.ChangePage.bind(this);
        this.Next = this.Next.bind(this);
        this.Previous = this.Previous.bind(this);
        this.SwitchToPage = this.SwitchToPage.bind(this);
        this.DeleteVersion = this.DeleteVersion.bind(this);
        this.EditVersion = this.EditVersion.bind(this);
        this.SetNewPage = this.SetNewPage.bind(this);
        this.GetTotalPages = this.GetTotalPages.bind(this);
    }

    GetTotalPages() {
        const { versionData } = this.props;
        const { loadDataLength } = this.state;
        return Math.ceil(versionData.length / loadDataLength);
    }

    DeleteVersion(intermediateIndex) {
        const { currentPage, loadDataLength } = this.state;
        let actualIndex = (loadDataLength * (currentPage - 1)) + intermediateIndex;
        this.props.onVersionDelete(actualIndex);
    }

    EditVersion(intermediateIndex) {
        const { currentPage, loadDataLength } = this.state;
        let actualIndex = (loadDataLength * (currentPage - 1)) + intermediateIndex;
        this.props.onVersionEdit(actualIndex);
    }

    ChangePage(newPageNo) {
        const { versionData } = this.props;
        const { loadDataLength } = this.state;
        var loadData = [];
        const startIndex = (newPageNo - 1) * loadDataLength;
        const endIndex = startIndex + loadDataLength;

        if (versionData.length < (endIndex + 1)) {
            loadData = versionData.slice(startIndex);
        }
        else {
            loadData = versionData.slice(startIndex, endIndex);
        }

        this.setState({ loadData: loadData, currentPage: newPageNo, newPage: newPageNo, versionDataLength: versionData.length });
    }

    Next() {
        const { currentPage } = this.state;
        this.ChangePage(currentPage + 1);
    }

    SwitchToPage(event) {
        if (event.key !== "Enter") {
            return;
        }

        const { currentPage } = this.state;
        var { newPage } = this.state;
        newPage = parseInt(newPage);
        const totalNoPages = this.GetTotalPages();
        if (!isNaN(newPage) && newPage > 0 && newPage != currentPage && newPage <= totalNoPages) {
            this.ChangePage(newPage);
        }
        else {
            this.setState({ newPage: currentPage });
        }
    }

    Previous() {
        const { currentPage } = this.state;
        this.ChangePage(currentPage - 1);
    }

    SetNewPage(event) {
        var newPageNo = event.target.value;
        this.setState({ newPage: newPageNo });
    }

    render() {
        const { loadData, currentPage, newPage, versionDataLength } = this.state;
        const totalNoPages = this.GetTotalPages();
        const disablePrevious = currentPage == 1;
        const disableNext = currentPage == totalNoPages;
        const { versionData } = this.props;
        const newPageNo = currentPage > totalNoPages ? totalNoPages - 1 : currentPage;
        if (versionData.length != versionDataLength) {
            this.ChangePage(newPageNo);
        }

        return (
            <div className="CA-DataTable">
                <table className={"table table-hover"}><thead><tr>
                    <th>Release date <span className="sub">(YYYY-MM-DD)</span></th>
                    <th>CleverAnt version</th>
                    <th>Created date <span className="sub">(YYYY-MM-DD)</span></th>
                    <th>Status</th>
                    <th className="CA-DeleteRow"><a href="javascript:void(0)" className="hideShow hide-header" title="Delete item">Delete</a></th>
                </tr></thead>
                    <tbody>{loadData.map((ver, index) => <VersionRow key={index} rowData={ver} deleteVersion={() => this.DeleteVersion(index)} editVersion={() => this.EditVersion(index)} versionIndex={index} />)}</tbody>
                    {versionData.length > 0 ?
                        <tfoot><tr><td></td><td className="PaginationDetails" colSpan="2"><span className="prev mx-3"><button className={"CA-newDocument CTA-active ca-primarybtn border-0"} disabled={disablePrevious} onClick={this.Previous}>&lt;</button></span><label htmlFor="paginationID" className="font-normal">Page</label> <input type="text" className="" value={newPage} onKeyPress={this.SwitchToPage} onChange={this.SetNewPage} id="paginationID" /> &#47;<strong> {totalNoPages}</strong><span className="next mx-3"><button className={"CA-newDocument CTA-active ca-primarybtn border-0"} disabled={disableNext} onClick={this.Next}>&gt;</button></span></td><td colSpan="2" align="right"></td></tr></tfoot> : null}
                </table>
            </div>
        );
    }
}